


























import { mapState } from "vuex";
import PointNotificationPanelSmall from "@/general/components/molecules/PointNotificationPanelSmall.vue";
import IconNotificationInvestedBlue from "@/common/components/icons/IconNotificationInvestedBlue.vue";
import IconNotificationInvestedGreen from "@/common/components/icons/IconNotificationInvestedGreen.vue";
import IconNotificationInvestedRed from "@/common/components/icons/IconNotificationInvestedRed.vue";
import { Prop, Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  components: {
    PointNotificationPanelSmall,
    IconNotificationInvestedBlue,
    IconNotificationInvestedGreen,
    IconNotificationInvestedRed
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class A01PointNotificationPanelInvested extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) investedReason!: string;
  @Prop({ type: Number, required: true }) point!: number;
  @Prop({ type: String, required: true }) url!: string;

  colors = ["blue", "green", "red"];
  currentColor = "blue";
  unit = commons.unit;

  get notificationIcon() {
    return "IconNotificationInvested" + this.toPascalCase(this.currentColor);
  }

  random(array: any) {
    return array[Math.floor(Math.random() * array.length)];
  }
  toPascalCase(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  created() {
    this.currentColor = this.random(this.colors);
  }
}
